import ReactDOM from "react-dom";
import * as React from "react";
var RenderComponent = /** @class */ (function () {
    function RenderComponent(domId, Component, props) {
        this.isActive = false;
        this.domId = domId;
        this.component = Component;
        this.props = props;
        this.activate();
    }
    RenderComponent.prototype.activate = function () {
        if (!this.isActive) {
            var domRef = document.getElementById(this.domId);
            if (domRef) {
                ReactDOM.render(React.createElement(this.component, this.props), domRef);
                this.isActive = true;
            }
        }
        return this;
    };
    RenderComponent.prototype.deactivate = function () {
        var domRef = document.getElementById(this.domId);
        if (domRef) {
            ReactDOM.unmountComponentAtNode(domRef);
            this.isActive = false;
        }
        return this;
    };
    return RenderComponent;
}());
export { RenderComponent };
//# sourceMappingURL=RenderComponent.js.map